/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paste_Attributes_TitleInputs */

const en_paste_attributes_title = /** @type {(inputs: Paste_Attributes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste Attributes`)
};

const fr_paste_attributes_title = /** @type {(inputs: Paste_Attributes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coller les attributs`)
};

const de_paste_attributes_title = /** @type {(inputs: Paste_Attributes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einfügen Attribute`)
};

const it_paste_attributes_title = /** @type {(inputs: Paste_Attributes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla attributi`)
};

const ru_paste_attributes_title = /** @type {(inputs: Paste_Attributes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставить атрибуты`)
};

const es_paste_attributes_title = /** @type {(inputs: Paste_Attributes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pegar atributos`)
};

const zh_cn2_paste_attributes_title = /** @type {(inputs: Paste_Attributes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴属性`)
};

const ja_paste_attributes_title = /** @type {(inputs: Paste_Attributes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`属性を貼り付け`)
};

const hi_paste_attributes_title = /** @type {(inputs: Paste_Attributes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विशेषताओं को पेस्ट करें`)
};

const pt_pt2_paste_attributes_title = /** @type {(inputs: Paste_Attributes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colar atributos`)
};

/**
* | output |
* | --- |
* | "Paste Attributes" |
*
* @param {Paste_Attributes_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const paste_attributes_title = /** @type {((inputs?: Paste_Attributes_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paste_Attributes_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_paste_attributes_title(inputs)
	if (locale === "de") return de_paste_attributes_title(inputs)
	if (locale === "it") return it_paste_attributes_title(inputs)
	if (locale === "ru") return ru_paste_attributes_title(inputs)
	if (locale === "es") return es_paste_attributes_title(inputs)
	if (locale === "zh-CN") return zh_cn2_paste_attributes_title(inputs)
	if (locale === "ja") return ja_paste_attributes_title(inputs)
	if (locale === "hi") return hi_paste_attributes_title(inputs)
	if (locale === "pt-PT") return pt_pt2_paste_attributes_title(inputs)
	return en_paste_attributes_title(inputs)
});